const CONTACT_PERMISSION_CHECKBOX_COPY = 'Hear about new restaurant launches and promotions';

// The heading and description are the radio's copy, so they go with it.
const CONTACT_PERMISSION_RADIO_COPY_FIELD_NAMES = [
  'contactPermission_Title',
  'contactPermission_Desc',
];

// The terms checkbox stays. These two are the "Terms and Privacy" heading and the
// "please state that you've read and agreed" line above it.
const TERMS_COPY_FIELD_NAMES = ['termsAndPrivacytitle', 'termsAndPrivacydesc'];

const HIDDEN_WHEN_CHECKBOX_FIELD_NAMES = [
  ...CONTACT_PERMISSION_RADIO_COPY_FIELD_NAMES,
  ...TERMS_COPY_FIELD_NAMES,
];

export const isContactPermissionRadio = (field: { name?: string | null; type?: string | null }) =>
  field.name === 'contactPermission' && /radio/i.test(field.type ?? '');

// Temporary compatibility adapter for PD-6990. Once every backend form returns the checkbox, this module can be deleted; see components/analytics/experiments/README.md for the rollout checklist.
// Turns the CMS Yes/No radio into an optional checkbox. Regions that require cookie consent (GDPR) start it unchecked so opting in is a choice; elsewhere it starts ticked.
export function contactPermissionCheckboxFields<
  T extends { name?: string | null; type?: string | null },
>(fields: T[] | null | undefined, checked: boolean) {
  if (!fields?.some(isContactPermissionRadio)) {
    return fields;
  }

  return fields
    .filter((field) => !HIDDEN_WHEN_CHECKBOX_FIELD_NAMES.includes(field.name ?? ''))
    .map((field) => {
      if (field.name === 'termsAndPrivacy') {
        // The heading above this checkbox is removed with the variant, so it needs its own space.
        return { ...field, pt: '15px' };
      }

      if (!isContactPermissionRadio(field)) {
        return field;
      }

      return {
        ...field,
        type: 'CHECKBOX',
        title: CONTACT_PERMISSION_CHECKBOX_COPY,
        value: checked ? '1' : '0',
        required: false,
        options: [],
      };
    });
}
